import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { GapEnum } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { PriceDetailsComponent } from '@app/feature/tariff/tariff-details/cards/price-details.component';
import { useTariffContext } from '@app/feature/tariff/tariff.context';

export const SimpleTariffCardComponent = (): React.JSX.Element => {
  const { t } = useTranslation();
  const { currency, elements } = useTariffContext();

  const priceComponents = useMemo(() => {
    const firstElement = elements[0];
    if (!firstElement) {
      toast.error('Tariff should not be empty. Possibly an outdated tariff.');
    }
    return firstElement!.priceComponents;
  }, [elements]);

  return (
    <Card gap={GapEnum.M}>
      <AccentTitle
        as={HeadingEnum.H2}
        icon="price"
        text={t('$.tariff-details.price.title')}
      />

      {priceComponents && (
        <PriceDetailsComponent
          currency={currency}
          priceComponents={priceComponents}
        />
      )}
    </Card>
  );
};
